import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment/moment";

// Components
import EditOrderItemsTable  from "./Components/EditOrderItemsTable.js"
import FilteredCustomerDropdown from "./Components/FilteredCustomerDropdown.js"
import SupplierDropdown from "./Components/SupplierDropdown";



export default function CreateOrder() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({

    });
    const [form, setForm] = useState({
        agentId: 0,
        customerId: 0,
        supplierId: 0,
        supplierContactId: 0,
        orderItems: [{ productCode: "0" }],
        dateOrdered: moment().format("YYYY-MM-DD"),
        invoiceAccount: "",
        deliveryAccount: "",
        supplierToInvoice: false,
        agentCommission: 0
        
    });
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);



    const [employees, setEmployees] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [supplierContacts, setSupplierContacts] = useState([]);




    const setField = (field, value) => {
        setForm((prevForm) => ({
            ...prevForm,
            [field]: value,
        }));
    };

    const handleSubmit = (event) => {

        console.log("handle submit", form)
        event.preventDefault();

        if (form.dateRequiredAlternate === "") {
            form.dateRequiredAlternate = null;
        }
        if (form.dateRequired === "") {
            form.dateRequired = null;
        }

        setFormErrors({
            dateOrdered: form.dateOrdered === undefined || form.dateOrdered === "" ? "Date Ordered is required" : "",
            agentId: form.agentId === undefined || form.agentId === 0 ? "Agent is required" : "",
            customerId: form.customerId === undefined || form.customerId === 0 ? "Customer is required" : "",
            supplierId: form.supplierId === undefined || form.supplierId === 0 ? "Supplier is required" : "",

        });
    }

    useEffect(() => {
        console.log("forMErrors changed")
        setIsValid(
            formErrors.dateOrdered === "" &&
            formErrors.agentId === "" && 
            formErrors.customerId === "" &&
            formErrors.supplierId === ""
        )

    }, [formErrors])

    useEffect(() => {

        if (isValid) {
            console.log("submitting...", isValid)
            setSubmitting(true);
            axios
                .post(`https://${process.env.REACT_APP_IP}/api/orders/`, form, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Orders/View/${res.data.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid]);

    useEffect(() => {
        // Load employees / users
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                if (res.status === 200) {
                    console.log("response:", res.data);
                    setEmployees(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })

        // Load customers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setCustomers(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })

        // Load suppliers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSuppliers(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })
    }, [])

    useEffect(() => {

        if (form.customerId === 0 || form.supplierId === 0) return;

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/${form.customerId}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {

                // check through the account codes to see if they have one for the selected supplier
                var accountNumber = res.data.accountNumbers.find((accountNumber) => accountNumber.supplierId === Number(form.supplierId));

                // Set the invoice account number
                if (accountNumber !== undefined && (form.invoiceAccount === "" || form.invoiceAccount === undefined)) {
                    setField("invoiceAccount", accountNumber.invoiceAccountNumber);
                }
                // set the delivery account number
                if (accountNumber !== undefined && (form.deliveryAccount === "" || form.deliveryAccount === undefined)) {
                    setField("deliveryAccount", accountNumber.deliveryAccountNumber);
                }

                
                
            })
            .catch((err) => {
                console.log("Error:", err);
            });

    }, [form.customerId, form.supplierId])

    useEffect(() => {

        if (form.customerId === 0) return;

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/${form.customerId}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {


                // Now set the billing/delivery addresses
                    setField("billingAddress", res.data.billingAddress);
                setField("deliveryPostcode", res.data.deliveryPostcode); 

                setField("deliveryAddress", res.data.deliveryAddress);
                setField("billingPostcode", res.data.billingPostcode);

            })
            .catch((err) => {
                console.log("Error:", err);
            });

    }, [form.customerId])

    // Supplier Changed - Look up contacts
    useEffect(() => {



        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/${form.supplierId}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {

                setSupplierContacts(res.data.contacts);

            })
            .catch((err) => {
                console.log("Error:", err);
            });

    }, [form.supplierId])




    return (
        <div className="page">

            {submitting && (
                <SubmittingDialog  />
            )}

            <div className="row">
                <div className="col-12">
                    <h1>
                      Create Order
                    </h1>
                </div>
            </div>

            <Form onSubmit={handleSubmit} noValidate >

            
                <div className="row">
                    <div className="col-md-6">

                        { /* Order/Required Date */}
                        <div className="row">
                            <div className="col-md-6">
                                { /* Date Ordered */}
                                <div className="form-group col-12">
                                    <label>Date Ordered</label>
                                    <Form.Control
                                        required
                                        type="date"
                                        placeholder="DD/MM/YYYY"
                                        isInvalid={formErrors && formErrors.dateOrdered}
                                        onChange={(e) => setField("dateOrdered", e.target.value)}
                                        value={form && moment(form.dateOrdered).format("YYYY-MM-DD")}

                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.dateOrdered}
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                { /* Date Required */}
                                <div className="form-group col-12">
                                    <label>Date Required</label>
                                    <Form.Control
                                        required
                                        type="date"
                                        placeholder="DD/MM/YYYY"
                                        isInvalid={formErrors && formErrors.dateRequired}
                                        onChange={(e) => setField("dateRequired", e.target.value)}
                                        value={form && form.dateRequired && moment(form.dateRequired).format("YYYY-MM-DD")}

                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.dateRequired}
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                            <div className="col-md-6">
                                { /* Date Required Alternative */}
                                <div className="form-group col-12">
                                    <label>Date Required (Alternative)</label>
                                    <Form.Control
                                        required
                                        type="date"
                                        placeholder="DD/MM/YYYY"
                                        isInvalid={formErrors && formErrors.dateRequiredAlternate}
                                        onChange={(e) => setField("dateRequiredAlternate", e.target.value)}
                                        value={form && form.dateRequiredAlternate && moment(form.dateRequiredAlternate).format("YYYY-MM-DD")}

                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.dateRequiredAlternate}
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                        </div>
                   
                        <div className="row">
                            <div className="col-md-12">

                                { /* Agent */}
                                <div className="form-group col-md-8">
                                    <label>Agent</label>
                                    <div className="select">
                                        <Form.Select
                                            onChange={(e) => setField("agentId", e.target.value)}
                                            isInvalid={formErrors && formErrors.agentId}
                                            value={form && form.agentId}
                                        >
                                            <option value="0" disabled>Please Select...</option>
                                            {employees && (employees.map((employee) => {
                                                return <option key={employee.id} value={employee.id}>{employee.name}</option>
                                            }))}
                                        </Form.Select>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.agentId}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                { /* Customer */}
                                <div className="form-group col-md-8">
                                    <label>Customer</label>
                                    <FilteredCustomerDropdown
                                        customers={customers}
                                        agentId={form.agentId}
                                        setField={setField}
                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.customerId}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Supplier */}
                                <div className="form-group col-md-8">
                                    <label>Supplier</label>
                                    <SupplierDropdown
                                        suppliers={suppliers}
                                        agentId={form.agentId}
                                        setField={setField}
                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.supplierId}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Supplier Reference */}
                                <div className="form-group col-6">
                                    <label>Supplier Reference</label>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g A1001"
                                        onChange={(e) => setField("supplierReference", e.target.value)}
                                        value={form && form.supplierReference}
                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.supplierReference}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Supplier Contact */}
                                <div className="form-group col-md-8">
                                    <label>Supplier Primary Contact</label>
                                    <div className="select">
                                        <Form.Select
                                            onChange={(e) => setField("supplierContactId", e.target.value)}
                                            isInvalid={formErrors && formErrors.supplierContactId}
                                            value={form && form.supplierContactId}
                                        >
                                            <option value="0" disabled>Please Select...</option>
                                            {supplierContacts && (supplierContacts.map((contact) => {
                                                return <option key={contact.id} value={contact.id}>{contact.name} ({contact.role})</option>
                                            }))}
                                        </Form.Select>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.agentId}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            
                                {/* Who Invoices? */}
                                <div className="form-group">
                                    <Form.Check
                                        type="radio"
                                        name="supplierToInvoice"
                                        label="AFS To Invoice"
                                        isInvalid={formErrors?.supplierToInvoice}
                                        checked={form.supplierToInvoice === false}
                                        onChange={() => setField("supplierToInvoice", false)}
                                    />

                                    <Form.Check
                                        type="radio"
                                        name="supplierToInvoice"
                                        label="Supplier To Invoice"
                                        isInvalid={formErrors?.supplierToInvoice}
                                        checked={form.supplierToInvoice === true}
                                        onChange={() => setField("supplierToInvoice", true)}
                                    />

                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors?.supplierToInvoice}
                                    </Form.Control.Feedback>
                                </div>
                                  

                            </div>
                        </div> 
                    </div>
                    <div className="col-md-6">
                        { /* Invoice Account */}
                        <div className="form-group col-6">
                            <label>Invoice Account</label>
                            <Form.Control
                                type="text"
                                placeholder="e.g A1001"
                                onChange={(e) => setField("invoiceAccount", e.target.value)}
                                value={form && form.invoiceAccount}
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.invoiceAccount}
                            </Form.Control.Feedback>
                        </div>

                        { /* Delivery Account */}
                        <div className="form-group col-6">
                            <label>Delivery Account</label>
                            <Form.Control
                                type="text"
                                placeholder="e.g A1001"
                                onChange={(e) => setField("deliveryAccount", e.target.value)}
                                value={form && form.deliveryAccount }
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.deliveryAccount}
                            </Form.Control.Feedback>
                        </div>

                        { /* Agent Commission */}
                        <div className="form-group col-6">
                            <label>Agent Commission</label>
                            <InputGroup>
                                <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                <Form.Control
                                    type="text"
                                    placeholder="e.g 79.99"
                                    onChange={(e) => setField("agentCommission", e.target.value)}
                                    value={form && form.agentCommission}
                                />
                            </InputGroup>
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.agentCommission}
                            </Form.Control.Feedback>
                        </div>

                        <div className="row">

                            { /* Billing Address */}
                            <div className="form-group col-6 p-0">
                                <label>Billing Address</label>
                                <InputGroup>
                                    <Form.Control as="textarea" rows="5"
                                        placeholder="e.g Suite 12B"
                                        isInvalid={formErrors && formErrors.billingAddress}
                                        onChange={(e) => setField("billingAddress", e.target.value)}
                                        value={form.billingAddress ?? ""}
                                    />
                                </InputGroup>
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.billingAddress}
                                </Form.Control.Feedback>

                                <label>Postcode</label>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g AB12 3CD"
                                        onChange={(e) => setField("billingPostcode", e.target.value)}
                                        value={form && form.billingPostcode}
                                    />
                                </InputGroup>
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.billingPostcode}
                                </Form.Control.Feedback>
                            </div>

                            { /* Delivery Address */}
                            <div className="form-group col-6">
                                <label>Delivery Address</label>
                                <InputGroup>
                                    <Form.Control as="textarea" rows="5"
                                        placeholder="e.g Suite 12B"
                                        isInvalid={formErrors && formErrors.deliveryAddress}
                                        onChange={(e) => setField("deliveryAddress", e.target.value)}
                                        value={form.deliveryAddress ?? ""}
                                    />
                                </InputGroup>
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.deliveryAccount}
                                </Form.Control.Feedback>

                                <label>Postcode</label>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g AB12 3CD"
                                        onChange={(e) => setField("deliveryPostcode", e.target.value)}
                                        value={form && form.deliveryPostcode}
                                    />
                                </InputGroup>
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.deliveryPostcode}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                </div>

                {/*###########*/}
                {/*Order Items*/}
                {/*###########*/}

                <div className="row">
                    <div className="col-12">
                        <EditOrderItemsTable orderItems={form.orderItems} setOrderItems={setField} supplier={form.supplierId}  />
                    </div>
                </div>




                {/*###########*/}


                <div className="row">
                    <div className="col-md-12">
                        { /* Comments */}
                        <div className="form-group col-6">
                            <label>Comments</label>
                            <Form.Control
                                as="textarea"
                                placeholder="e.g no delivery after 2pm on Fridays"
                                onChange={(e) => setField("comments", e.target.value)}
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.comments}
                            </Form.Control.Feedback>
                        </div>
                    </div>
                </div>

                { /* Haulier */}
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group col-6">
                            <label>Haulier</label>
                            <Form.Control
                                type="text"
                                placeholder="e.g John Smith Transportation"
                                onChange={(e) => setField("haulier", e.target.value)}
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.haulier}
                            </Form.Control.Feedback>
                        </div>
                    </div>
                </div>

                { /* Invoice Number */}
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group col-6">
                            <label>AFS Invoice No.</label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="e.g ABC123"
                                isInvalid={formErrors && formErrors.invoiceNumber}
                                onChange={(e) => setField("invoiceNumber", e.target.value)}
                                value={form && form.invoiceNumber}
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.invoiceNumber}
                            </Form.Control.Feedback>
                        </div>
                    </div>
                </div>

                { /* Bill Number */}
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group col-6">
                            <label>AFS Bill No.</label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="e.g ABC123"
                                isInvalid={formErrors && formErrors.billNumber}
                                onChange={(e) => setField("billNumber", e.target.value)}
                                value={form && form.billNumber}
                            />
                            <Form.Control.Feedback className="text-danger" type="invalid">
                                {formErrors.billNumber}
                            </Form.Control.Feedback>
                        </div>
                    </div>
                </div>
                


                <hr />

                {formErrors.general && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-danger">
                                {formErrors.general}
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-primary" type="submit" >Create Order</button>
                        <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Orders/`) }}>Cancel</button>
                    </div>
                </div>
            </Form>

        </div>
  )
}
